import React, { useRef, useState } from 'react';
import Rodal from '../../../../../components/Rodal/Rodal';
import { ModalBody, ModalHeader } from 'reactstrap';
import { Formik } from 'formik';
import { FileSelector } from '../../../../../components/FileSelector/FileSelector';
import ButtonLoader from '../../../../../components/Layout/Buttons/ButtonLoader';
import './MarkDdNdaExecutedPopup.scss';

interface MarkDdNdaExecutedPopupProps {
    isVisible: boolean;
    onClose: () => void;
    onConfirm: (file?: File) => void;
    isLoading: boolean;
}

export const MarkDdNdaExecutedPopup = (
    props: MarkDdNdaExecutedPopupProps
) => {
    const formRef = useRef<any>();
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const resetState = () => {
        setSelectedFile(null);
        formRef.current?.resetForm();
    };

    const handleClose = () => {
        resetState();
        props.onClose();
    };

    const changeFileHandler = (file: File) => {
        if (file) {
            setSelectedFile(file);
            formRef.current.setFieldValue('sourceFile', file.name, true);
        }
    };

    return (
        <Rodal
            className="mark-dd-nda-executed-popup"
            visible={props.isVisible}
            onClose={handleClose}>
            <ModalHeader>Mark Document as Executed</ModalHeader>
            <ModalBody>
                <p className="mark-dd-nda-executed-description">
                    Marking this DD NDA as executed will close the buyer's
                    signature step without requiring an e-signature. You may
                    optionally attach a signed copy of the document.
                </p>
                <Formik
                    innerRef={formRef}
                    initialValues={{ sourceFile: '' }}
                    onSubmit={() => {}}>
                    {({ values }) => (
                        <FileSelector
                            disabled={props.isLoading}
                            extension=".pdf"
                            file={selectedFile}
                            setFile={changeFileHandler}
                            fileName={values.sourceFile}
                            downloadFile={() => {}}
                            setIsDocumentsHistoryPopupVisible={() => {}}
                            oldDocumentDetailsList={[]}
                        />
                    )}
                </Formik>
                <div className="buttons-wrapper">
                    <button
                        className="btn btn-outline-secondary"
                        disabled={props.isLoading}
                        onClick={handleClose}>
                        Cancel
                    </button>
                    <ButtonLoader
                        disabled={props.isLoading}
                        onClick={() => props.onConfirm(selectedFile)}
                        className="btn btn-primary"
                        buttonText="Confirm"
                        loaderButtonText="Confirm"
                        isLoading={props.isLoading}
                    />
                </div>
            </ModalBody>
        </Rodal>
    );
};

export default MarkDdNdaExecutedPopup;
